import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {MatCardModule} from "@angular/material";
import {TaskDetailsPage} from "./task-details";
import {SellionsFormsModule} from "../../../../submodules/sellions_forms/projects/forms/src/lib/forms.module";
import {ComponentsModule} from "../../../../components/components.module";
import { SellionsLayoutRendererLibModule } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';

@NgModule({
  declarations: [
    TaskDetailsPage,
  ],
  imports: [
    IonicPageModule.forChild(TaskDetailsPage),
    ComponentsModule,
    SellionsLayoutRendererLibModule,
    SellionsFormsModule,
    MatCardModule
  ],
})
export class TaskDetailsModule {
}



// WEBPACK FOOTER //
// ./src/modules/tasks/pages/task-details/task-details.module.ts